import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material";

const FooterContainer = styled(Container)`
    background-color:#860C0A;
    padding-top:70px;
    padding-bottom:70px;
    display:flex;
    justify-content:center;
    @media (max-width: 1024px){
        padding-top:40px;
        padding-bottom:40px;
    }
`
const ContentWrapper = styled(Grid)`
    display:flex;
    justify-content:center;
`
const P = styled.p`
    color:#fff;
    font-size:18px;
    font-family:Oswald-semibold;
    text-align:center;
    @media (max-width: 900px){
        font-size:14px;
    }
`
const EmailLink = styled.a`
    color:#FEC925;
    text-decoration:underline;
`
const CopyRightsContainer = styled(Container)`
    padding:15px 0px;
    background-color:#000;
    @media (max-width: 600px){
        padding:10px 0px;
    }
`
const CopyRights = styled.p`
    color:#fff;
    font-size:16px;
    font-family:poppins;
    text-align:center;
    @media (max-width: 600px){
        font-size:12px;
    }
`
function Footer(){
    return(
        <>
        <FooterContainer maxWidth="xxl" id="tokenomics">
            <ContentWrapper container item xs={12} sm={12} md={12} lg={12} xl={8}>
                <Grid item xs={12} sm={12} md={10}>
                    <P>$gATE5 coin has no association with the original creator of the Luffy.
                        This token is simply paying homage to a Luffy we all love and recognize.
                    </P>
                    <P>$Gate5 is a meme coin with no intrinsic value or expectation of financial return.
                         There is no formal team or roadmap. the coin is completely useless and for
                          entertainment purposes only.
                    </P>
                    <P>Need Something? Drop Us A Message: <EmailLink href='mailto:"hello@luffytoken.com"'>hello@luffytoken.com</EmailLink></P>
                </Grid>
            </ContentWrapper>
        </FooterContainer>
        <CopyRightsContainer maxWidth="xxl">
            <Grid container item xs={12} sm={12}>
                <Grid item xs={12} sm={12} md={12}>
                    <CopyRights>© 2023 by Luffytoken. All rights reserved!</CopyRights>
                </Grid>
            </Grid>
        </CopyRightsContainer>
        </>
    );
}

export default Footer;